export function Skeleton({ width = '100%', height = '16px', radius = '6px', style }) {
  return (
    <div
      className="skeleton"
      style={{ width, height, borderRadius: radius, flexShrink: 0, ...style }}
    />
  );
}

export function SkeletonCard({ lines = 3 }) {
  return (
    <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <Skeleton height="20px" width="60%" />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} height="14px" width={i === lines - 1 ? '40%' : '100%'} />
      ))}
    </div>
  );
}

export function SkeletonRow({ cols = 4 }) {
  return (
    <div style={{ display: 'flex', gap: '16px', padding: '14px 16px', borderBottom: '1px solid var(--border-light)' }}>
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} height="14px" style={{ flex: 1 }} />
      ))}
    </div>
  );
}

export function SkeletonList({ rows = 3, cols = 4 }) {
  return (
    <div>
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonRow key={i} cols={cols} />
      ))}
    </div>
  );
}

export function SkeletonStat() {
  return (
    <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '16px' }}>
      <Skeleton height="12px" width="50%" />
      <Skeleton height="28px" width="70%" />
      <Skeleton height="12px" width="40%" />
    </div>
  );
}
